export default __webpack_public_path__ + "static/media/colusa-motel.7e1d6d88.jpg";